<template>
  <MainNavbar class="edu-fixed-nav" />
  <PaymentFailed />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import PaymentFailed from "../components/Payment/PaymentFailed.vue";

export default defineComponent({
  name: "PaymentFailedPage",
  components: {
    MainNavbar,
    PaymentFailed,
  },
});
</script>
